import axiosInstance from "./axiosConfig";
import { handleAPIError } from "./utils/errors";

/** What a firm member may do, by name; mirrors `law_firm_admin_access.MEMBER_CAPABILITY_LABELS`. */
export type FirmCapability =
  | "edit_company_playbook"
  | "manage_firm_settings"
  | "manage_permissions"
  | "review_billing"
  | "manage_skills"
  | "edit_firm_library";

export type MyPermissions = {
  law_firm_id: string | null;
  role: string | null;
  capabilities: Record<FirmCapability, boolean>;
};

/** `GET /api/me/permissions`: the caller's capability map at their firm. */
export const getMyPermissions = async (): Promise<MyPermissions> => {
  try {
    const response = await axiosInstance.get<MyPermissions>("/me/permissions");
    return response.data;
  } catch (error) {
    const apiError = handleAPIError(error);
    throw apiError;
  }
};
